export default {
	add: 'إضافة سجل دوام',
	importFingerprint: 'استيراد ملف البصمات',

	type: 'النوع',

	table: {
		employee: 'الموظف',
		section: 'القسم',
		date: 'التاريخ',

		firstFinderPrint: 'اول بصمة',
		lastFinderPrint: 'اخر بصمة',
		fingerPrintCount: 'عدد البصمات',
		duration: 'المدة',
		durationToAll: 'المدة إلى الدوام',
		delay: 'التأخير',
		earlyLeave: 'الانصراف المبكر',
		unjustifiedTime: 'الوقت الغير مبرر',

		earlyLeaveToVacation: 'الخروج المبكر للإجازة',
		lateArriveFromVacation: 'تأخير العودة من الإجازة',
		vacationOverTime: 'تجاوز مدة الإجازة',

		extraBefore: 'إضافي قبل العمل',
		extraAfter: 'إضافي بعد العمل',
		extraVacation: 'إضافي في العطلة',
		extraTotal: 'الإضافي',

		// startTime: 'وقت الوصول',
		// endTime: 'وقت المغادرة',
		// extra: 'إضافي',
	},

	employeeTypes: {
		all: 'الكل',
		committed: 'الملتزمون',
		late: 'المتاخرون',
		earlyLeave: 'الانصراف المبكر',
		absence: 'الغياب',
	},

	tooltips: {
		showFinderPrints: 'عرض البصمات',
	},
	'checked': 'تم التدقيق'
};
